import { makeStyles } from 'tss-react/mui';

import { ScreenSize } from '@/styles/legacyComponentLibraryTheme';

const useStyles = makeStyles({ name: 'LeadFormV2Component' })(
  ({ brandType, brandColors, breakpoints, typography }) => ({
    leadForm: {
      gap: typography.pxToRem(20),
      backgroundColor: brandColors.offWhite,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      border: `1px solid ${brandColors.grey} `,
      borderRadius: typography.pxToRem(8),
      width: typography.pxToRem(560),
      paddingTop: typography.pxToRem(50),
      paddingBottom: typography.pxToRem(60),
      paddingLeft: '5%',
      paddingRight: '5%',
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        border: 'none',
        paddingBottom: typography.pxToRem(85),
        paddingLeft: '10%',
        paddingRight: '10%',
        width: '100%',
      },
    },
    inputLabel: {
      fontWeight: 400,
      fontSize: typography.pxToRem(14),
      lineHeight: typography.pxToRem(20),
      letterSpacing: '-0.02rem',
      color: brandColors.heroBlue,
      marginBottom: typography.pxToRem(4),
    },
    errorText: {
      marginTop: typography.pxToRem(4),
      color: brandColors.errorMain,
      ...brandType['body-s'],
    },
    tosText: {
      ...brandType['body-s'],
      marginBottom: typography.pxToRem(30),
    },
    splitRow: {
      gap: typography.pxToRem(20),
    },
    paragraphOverride: {
      '& p, a': {
        fontSize: '0.75rem !important',
        fontWeight: '500 !important',
        lineHeight: '0.75rem !important',
        letterSpacing: '-0.02rem !important',
      },
    },
    hidden: {
      display: 'none !important',
    },
  })
);

export default useStyles;
